import { BrowserRouter as Router } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { ThemeProvider } from '@material-ui/core';
import { createTheme } from 'src/theme';
import { AuthProvider } from 'src/contexts/JWTAuthContext';
import Routes from './Routes';
import GlobalStyles from 'src/components/GlobalStyles';
import CssBaseline from '@material-ui/core/CssBaseline';
import { SnackbarProvider } from 'notistack';
// import { createRef } from 'react';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

function ErrorFallback({ error, resetErrorBoundary }) {
  return (
    <div role="alert">
      <p>Something went wrong:</p>
      <pre>{error.message}</pre>
      <button onClick={resetErrorBoundary}>Try again</button>
    </div>
  );
}

// const notistackRef = createRef();
// const onClickDismiss = (key) => () => {
//   notistackRef.current.closeSnackbar(key);
// };

function App() {
  const theme = createTheme({
    direction: 'ltr',
    responsiveFontSizes: true,
    theme: 'DARK',
  });
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <QueryClientProvider client={queryClient}>
          <Router>
            <AuthProvider>
              <SnackbarProvider
                maxSnack={3}
                autoHideDuration={3000}
                anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
                // ref={notistackRef}
                // action={(key) => <Button onClick={onClickDismiss(key)}>Dismiss</Button>}
              >
                <GlobalStyles />
                <Routes />
              </SnackbarProvider>
            </AuthProvider>
          </Router>
          <ReactQueryDevtools />
        </QueryClientProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
